export const MAX_PERIODS = 10;

export const DEFAULT_PROJECTION_SPAN_DAYS = 28;

export const DATE_INPUT_FORMAT = 'YYYY-MM-DD';
